import { logger } from '$utils'
import dayjs from 'dayjs'
import { isAppStateReady } from 'src/state/store'
import { defer } from 'react-router-dom'
import useTimeclockStore from '../store'
import { getQueryStringParamsFromStringUrl } from '$utils'
import { getDateRangeFromQueryStringOrAppStore } from '../_common/helpers/queryString'

export default async function loader({ request }) {
  const queryParams = getQueryStringParamsFromStringUrl(request.url)

  logger.debug(
    '[loader] About to await AppState being ready in StaffClocks loader'
  )
  await isAppStateReady()
  logger.debug('[loader] AppState should now be ready in StaffClocks loader')

  const { startDateTime, endDateTime } =
    getDateRangeFromQueryStringOrAppStore(queryParams)

  const getTimeClockins = useTimeclockStore
    .getState()
    .getTimeClockins(startDateTime, endDateTime, true)

  const getStaffMembers = useTimeclockStore.getState().getStaffMembers(dayjs())

  const getPackages = useTimeclockStore.getState().getPackages()

  return defer({
    data: Promise.all([getTimeClockins, getStaffMembers, getPackages])
      .then(() => true)
      .catch((error) => {
        logger.error('Staff Clocks Promise.all error', error)
        return false
      }),
  })
}
